// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { View, StyleSheet } from "react-native";

// components
import Heading from "../Heading";
import Text from "../Text";
import Stack from "../Stack";
import Floor from "../Floor";
import { Row, Col } from "../Grid2";

// libraries
import { emToPx } from "../../libraries";
import { get } from "@cloudspire/legacy-shared/src/libraries";

type PropsType = {
  pieceList: { floor: string; name: string; surface: number; about: string }[];
};

function getBeds({ piece }) {
  const beds = [];

  if (get(piece, "beds80")) {
    beds.push({ type: "beds80", value: piece.beds80 });
  }

  if (get(piece, "beds90")) {
    beds.push({ type: "beds90", value: piece.beds90 });
  }

  if (get(piece, "beds120")) {
    beds.push({ type: "beds120", value: piece.beds120 });
  }

  if (get(piece, "beds140")) {
    beds.push({ type: "beds140", value: piece.beds140 });
  }

  if (get(piece, "beds160")) {
    beds.push({ type: "beds160", value: piece.beds160 });
  }

  if (get(piece, "beds180")) {
    beds.push({ type: "beds180", value: piece.beds180 });
  }

  if (get(piece, "beds200")) {
    beds.push({ type: "beds200", value: piece.beds200 });
  }

  if (get(piece, "bedsOverlaid")) {
    beds.push({ type: "bedsOverlaid", value: piece.bedsOverlaid });
  }

  return beds;
}

const styles = StyleSheet.create({
  heading: {
    color: "#3a485f",
    fontWeight: "500",
  },
  pieceHeading: {
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
  },
  pieceName: {
    fontSize: emToPx(1.25),
    color: "#f45d5c",
  },
  pieceFloor: {
    fontWeight: "700",
    fontSize: emToPx(0.875),
    marginLeft: emToPx(0.75),
  },
  pieceSurface: {
    fontWeight: "700",
    fontSize: emToPx(0.875),
    marginLeft: emToPx(0.75),
  },
  beds: {
    fontSize: emToPx(0.75),
    fontWeight: "700",
  },
});

const RoomPieceList: React.FunctionComponent<PropsType> = (props) => {
  const { pieceList } = props;

  const intl = useIntl();

  return (
    <>
      <Heading level={3} size="1.625em" style={styles.heading}>
        {intl.formatMessage({
          defaultMessage: "Agencement de l’hébergement",
        })}
      </Heading>
      <Stack marginTop={0.5} />
      <Row type="column" gutter={1}>
        {pieceList.map((piece, index) => {
          const beds = getBeds({ piece });

          return (
            <Col key={index}>
              <View style={styles.pieceHeading}>
                <Text style={styles.pieceName}>{piece.name}</Text>

                {null !== piece.floor && (
                  <Text style={styles.pieceFloor}>
                    <Floor floor={piece.floor} />
                  </Text>
                )}

                {Boolean(piece.surface) && (
                  <Text style={styles.pieceSurface}>
                    {piece.surface} m{"\u00B2"}
                  </Text>
                )}
              </View>
              <Stack marginTop={0.5} />
              <Text>{piece.about}</Text>
              {beds.length > 0 && (
                <View>
                  <Text style={styles.beds}>
                    {beds
                      .filter((bed) => parseInt(bed.value) > 0)
                      .map(function (bed) {
                        return intl.formatMessage(
                          {
                            defaultMessage:
                              "{numberOfBeds, plural, one {# lit} other {# lits}} {bedType, select, beds80 {80cm} beds90 {90cm} beds120 {120cm} beds140 {140cm} beds160 {160cm} beds180 {180cm} beds200 {200cm} bedsOverlaid {à étage} other {{bedType}}}",
                          },
                          {
                            bedType: bed.type,
                            numberOfBeds: bed.value,
                          }
                        );
                      })
                      .join("   •   ")}
                  </Text>
                </View>
              )}
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default RoomPieceList;
